import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/saga-blue/theme.css";
import "primeicons/primeicons.css";
import { LuClock10 } from "react-icons/lu";

const TimerPickerComponent = ({ defaultValue, onChange }) => {
  const defaultTime = defaultValue ? new Date(defaultValue) : new Date();
  defaultTime.setHours(12);
  defaultTime.setMinutes(0);
  defaultTime.setSeconds(0);

  const [date, setDate] = useState(defaultTime);

  const handleTimeChange = (e) => {
    setDate(e.value);
    onChange(e.value);
  };

  useEffect(() => {
    if (defaultValue) {
      // Parse the string representation of the time
      const [hours, minutes] = defaultValue.split(":");
      const [time, period] = minutes?.split(" ");
      let hours24 = parseInt(hours, 10);
      if (period === "PM" && hours24 !== 12) {
        hours24 += 12; // Convert to 24-hour format if PM
      } else if (period === "AM" && hours24 === 12) {
        hours24 = 0; // Convert 12 AM to 0 hours
      }
      // Create a new Date object with the parsed time
      const parsedDate = new Date();
      parsedDate.setHours(hours24);
      parsedDate.setMinutes(parseInt(time, 10));
      setDate(parsedDate);
    }
  }, [defaultValue]);

  return (
    <div className="time_picker">
      <Calendar
        value={date}
        onChange={handleTimeChange}
        showIcon
        timeOnly
        hourFormat="12"
        icon={() => <LuClock10 className="clock_icon" />}
      />
    </div>
  );
};

export default TimerPickerComponent;
